// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__rzTrX","label":"Radio_label__1fkqO","checkMark":"Radio_checkMark__5wtvI","disabled":"Radio_disabled__1CH50"};